/**
 * @generated SignedSource<<d673a9a09901254c04c716f7575ea48f>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "model"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = [
        {
            "kind": "Variable",
            "name": "nameContains",
            "variableName": "filter"
        }
    ], v5 = [
        (v3 /*: any*/)
    ], v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduleId",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
    }, v11 = [
        (v9 /*: any*/),
        (v10 /*: any*/),
        (v3 /*: any*/)
    ], v12 = {
        "kind": "InlineFragment",
        "selections": (v5 /*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v15 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "concreteType": "Avatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Literal",
                        "name": "queryTransform",
                        "value": "width=300&height=300&mode=crop&scale=both"
                    }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": "url(queryTransform:\"width=300&height=300&mode=crop&scale=both\")"
            },
            (v3 /*: any*/)
        ],
        "storageKey": null
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            (v9 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstname",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastname",
                "storageKey": null
            }
        ],
        "type": "User",
        "abstractKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "SchedulableEntityListItem_removeResourceFromScheduleAssignmentTypeMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "RemoveResourceFromScheduleAssignmentTypePayload",
                    "kind": "LinkedField",
                    "name": "removeResourceFromScheduleAssignmentType",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleAssignmentTypeResource",
                            "kind": "LinkedField",
                            "name": "resourceEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleAssignmentTypeResource",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleAssignmentType",
                                            "kind": "LinkedField",
                                            "name": "scheduleAssignmentType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "ScheduleAssignmentTypeResourcesUpdateModal_scheduleAssignmentType"
                                                },
                                                {
                                                    "args": (v4 /*: any*/),
                                                    "kind": "FragmentSpread",
                                                    "name": "RunningScheduleAssignmentType_scheduleAssignmentType"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": "resourceEdge2",
                            "args": null,
                            "concreteType": "EdgeOfScheduleAssignmentTypeResource",
                            "kind": "LinkedField",
                            "name": "resourceEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleAssignmentTypeResource",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleAssignmentType",
                                            "kind": "LinkedField",
                                            "name": "scheduleAssignmentType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "ScheduleAssignmentTypeResourceTable_scheduleAssignmentType"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "SchedulableEntityListItem_removeResourceFromScheduleAssignmentTypeMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "RemoveResourceFromScheduleAssignmentTypePayload",
                    "kind": "LinkedField",
                    "name": "removeResourceFromScheduleAssignmentType",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleAssignmentTypeResource",
                            "kind": "LinkedField",
                            "name": "resourceEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleAssignmentTypeResource",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleAssignmentType",
                                            "kind": "LinkedField",
                                            "name": "scheduleAssignmentType",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AssignmentType",
                                                    "kind": "LinkedField",
                                                    "name": "assignmentType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "AssetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "AssetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Asset",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SchedulableAsset",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "schedulableEntity",
                                                                                    "plural": false,
                                                                                    "selections": (v5 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v3 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "title",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "UserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "users",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "UserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "User",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SchedulableUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "schedulableEntity",
                                                                                    "plural": false,
                                                                                    "selections": (v5 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v3 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v6 /*: any*/),
                                                    "concreteType": "ScheduleAssignmentTypeResourceConnection",
                                                    "kind": "LinkedField",
                                                    "name": "resources",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleAssignmentTypeResourceEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleAssignmentTypeResource",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "schedulableEntityId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleAssignmentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "scheduleAssignmentType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "assignmentTypeId",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v7 /*: any*/),
                                                                                (v3 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "schedulableEntity",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v8 /*: any*/),
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": (v11 /*: any*/),
                                                                                    "type": "SchedulableAsset",
                                                                                    "abstractKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": (v11 /*: any*/),
                                                                                    "type": "SchedulableUser",
                                                                                    "abstractKey": null
                                                                                },
                                                                                (v12 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v8 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v13 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v14 /*: any*/)
                                                    ],
                                                    "storageKey": "resources(first:10)"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v6 /*: any*/),
                                                    "filters": null,
                                                    "handle": "connection",
                                                    "key": "ScheduleAssignmentTypeResourcesUpdateModal_scheduleAssignmentType_resources",
                                                    "kind": "LinkedHandle",
                                                    "name": "resources"
                                                },
                                                (v7 /*: any*/),
                                                {
                                                    "alias": "filteredResources",
                                                    "args": (v4 /*: any*/),
                                                    "concreteType": "ScheduleAssignmentTypeResourceConnection",
                                                    "kind": "LinkedField",
                                                    "name": "resources",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleAssignmentTypeResourceEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleAssignmentTypeResource",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "schedulableEntity",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v8 /*: any*/),
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        (v3 /*: any*/),
                                                                                        (v9 /*: any*/),
                                                                                        (v10 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Asset",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "asset",
                                                                                                    "plural": false,
                                                                                                    "selections": (v5 /*: any*/),
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SchedulableAsset",
                                                                                            "abstractKey": null
                                                                                        }
                                                                                    ],
                                                                                    "type": "ISchedulableEntity",
                                                                                    "abstractKey": "__isISchedulableEntity"
                                                                                },
                                                                                (v12 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Schedule",
                                                    "kind": "LinkedField",
                                                    "name": "schedule",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "currentUserPermissions",
                                                            "storageKey": null
                                                        },
                                                        (v3 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": "resourceEdge2",
                            "args": null,
                            "concreteType": "EdgeOfScheduleAssignmentTypeResource",
                            "kind": "LinkedField",
                            "name": "resourceEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleAssignmentTypeResource",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleAssignmentType",
                                            "kind": "LinkedField",
                                            "name": "scheduleAssignmentType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": (v15 /*: any*/),
                                                    "concreteType": "ScheduleAssignmentTypeResourceConnection",
                                                    "kind": "LinkedField",
                                                    "name": "resources",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleAssignmentTypeResourceEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleAssignmentTypeResource",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "schedulableEntity",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v8 /*: any*/),
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Asset",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "asset",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v16 /*: any*/),
                                                                                                (v3 /*: any*/),
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        (v17 /*: any*/),
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                (v9 /*: any*/)
                                                                                                            ],
                                                                                                            "type": "Asset",
                                                                                                            "abstractKey": null
                                                                                                        },
                                                                                                        (v18 /*: any*/)
                                                                                                    ],
                                                                                                    "type": "IHaveAvatar",
                                                                                                    "abstractKey": "__isIHaveAvatar"
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "type": "SchedulableAsset",
                                                                                    "abstractKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "User",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        (v17 /*: any*/),
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                (v9 /*: any*/),
                                                                                                                (v16 /*: any*/)
                                                                                                            ],
                                                                                                            "type": "Asset",
                                                                                                            "abstractKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                (v16 /*: any*/)
                                                                                                            ],
                                                                                                            "type": "Company",
                                                                                                            "abstractKey": null
                                                                                                        },
                                                                                                        (v18 /*: any*/)
                                                                                                    ],
                                                                                                    "type": "IHaveAvatar",
                                                                                                    "abstractKey": "__isIHaveAvatar"
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "employeeId",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fullName",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v3 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "type": "SchedulableUser",
                                                                                    "abstractKey": null
                                                                                },
                                                                                (v12 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v3 /*: any*/),
                                                                        (v8 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v13 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v14 /*: any*/)
                                                    ],
                                                    "storageKey": "resources(first:50)"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v15 /*: any*/),
                                                    "filters": [],
                                                    "handle": "connection",
                                                    "key": "ScheduleAssignmentTypeResourceTable_scheduleAssignmentType_resources",
                                                    "kind": "LinkedHandle",
                                                    "name": "resources"
                                                },
                                                (v3 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v3 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "911a9f5d446862c6ad3a673870d2d9b4",
            "id": null,
            "metadata": {},
            "name": "SchedulableEntityListItem_removeResourceFromScheduleAssignmentTypeMutation",
            "operationKind": "mutation",
            "text": "mutation SchedulableEntityListItem_removeResourceFromScheduleAssignmentTypeMutation(\n  $model: RemoveResourceFromScheduleAssignmentTypeRequestInput!\n  $filter: String\n) {\n  removeResourceFromScheduleAssignmentType(model: $model) {\n    resourceEdge {\n      node {\n        id\n        scheduleAssignmentType {\n          ...ScheduleAssignmentTypeResourcesUpdateModal_scheduleAssignmentType\n          ...RunningScheduleAssignmentType_scheduleAssignmentType_1HcttM\n          id\n        }\n      }\n    }\n    resourceEdge2: resourceEdge {\n      node {\n        scheduleAssignmentType {\n          ...ScheduleAssignmentTypeResourceTable_scheduleAssignmentType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Avatar_iHaveAvatar on IHaveAvatar {\n  __isIHaveAvatar: __typename\n  avatar {\n    url(queryTransform: \"width=300&height=300&mode=crop&scale=both\")\n    id\n  }\n  ... on Asset {\n    color\n    name\n  }\n  ... on Company {\n    name\n  }\n  ... on User {\n    color\n    firstname\n    lastname\n  }\n}\n\nfragment RunningScheduleAssignmentType_scheduleAssignmentType_1HcttM on ScheduleAssignmentType {\n  id\n  assignmentType {\n    id\n    title\n  }\n  filteredResources: resources(nameContains: $filter) {\n    edges {\n      node {\n        id\n        schedulableEntity {\n          __typename\n          ... on ISchedulableEntity {\n            __isISchedulableEntity: __typename\n            id\n            color\n            displayName\n            ... on SchedulableAsset {\n              asset {\n                id\n              }\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment SchedulableEntityListItem_scheduleAssignmentTypeResource on ScheduleAssignmentTypeResource {\n  id\n  scheduleAssignmentType {\n    assignmentTypeId\n    scheduleId\n    id\n  }\n  schedulableEntity {\n    __typename\n    ... on SchedulableAsset {\n      color\n      displayName\n      id\n    }\n    ... on SchedulableUser {\n      color\n      displayName\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ScheduleAssignmentTypeResourceTable_scheduleAssignmentType on ScheduleAssignmentType {\n  resources(first: 50) {\n    edges {\n      node {\n        schedulableEntity {\n          __typename\n          ... on SchedulableAsset {\n            asset {\n              ...Avatar_iHaveAvatar\n              name\n              id\n            }\n          }\n          ... on SchedulableUser {\n            user {\n              ...Avatar_iHaveAvatar\n              ...UserNameLabel_user\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ScheduleAssignmentTypeResourcesUpdateModal_scheduleAssignmentType on ScheduleAssignmentType {\n  id\n  assignmentType {\n    id\n    assets {\n      edges {\n        node {\n          schedulableEntity {\n            id\n          }\n          id\n        }\n      }\n    }\n    title\n    users {\n      edges {\n        node {\n          schedulableEntity {\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n  resources(first: 10) {\n    edges {\n      node {\n        id\n        schedulableEntityId\n        ...SchedulableEntityListItem_scheduleAssignmentTypeResource\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  scheduleId\n}\n\nfragment UserNameLabel_user on User {\n  employeeId\n  fullName\n}\n"
        }
    };
})();
node.hash = "339f93c18e5b4d7ec309d41831fa28bf";
export default node;
